import Kernel from "@oilstone/kernel";

class Navigation {
    static masterRecord = null;

    static push(to) {
        const router = Kernel.resolve('router');

        return router.push(to);
    }

    /**
     * @param {string} to
     */
    static append(to) {
        return Kernel.resolve('router').push({
            path: to,
        });
    }

    static currentRoute() {
        return Kernel.resolve('router').currentRoute;
    }
}

export default Navigation;
